import { makeStyles } from '@material-ui/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
  formContent: {
    padding: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
}))

export default useStyles
